import AlertService from "@/defines/service/alertService";
import LoadingService from "@/defines/service/loadingService";
import { useUserStore } from "@/defines/store/userStore";
import { useClerk, UserProfile } from "@clerk/clerk-react"
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function PersonalInfo() {
    const alertService = AlertService();
    const loadingService = LoadingService();
    const { signOut } = useClerk()
    const navigate = useNavigate();
    const changeToInsurance = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': useUserStore.getState().token
        }
        loadingService.ShowLoading('處理中...');
        const payload = {
            type: 'AddInsuranceOrg',
        };

        // Send POST request to your Lambda endpoint
        await axios.post(import.meta.env.VITE_REQUEST_CLERK, payload, {
            headers: headers
        })
            .then(async (response) => {
                let isComplete = false;
                console.log('start checkStatus');
                const checkStatus = async () => {
                    try {
                        const statusResponse = await axios.post(
                            import.meta.env.VITE_REQUEST_CLERK,
                            { type: 'CheckIsInsurance' },
                            { headers: headers }
                        );
                        console.log('Status check response:', statusResponse);
                        return statusResponse?.data?.isMember === true;
                    } catch (error) {
                        loadingService.HiddenLoading();
                        alertService.Error(`處理失敗 ! 請重新嘗試`);
                        console.log('change plan error = ', error);
                        throw error;
                    }
                };

                while (!isComplete) {
                    try {
                        isComplete = await checkStatus();
                        if (!isComplete) {
                            console.log('retry');
                            await new Promise(resolve => setTimeout(resolve, 5000));
                        }
                    } catch (error) {
                        break;
                    }
                }

                console.log('change plan res = ', response);
                alertService.Success(`${response?.data}`);
                loadingService.HiddenLoading();
                navigate('/after-login?type=insuranceRedirect');

                // setTimeout(() => {
                //     signOut();
                //     loadingService.HiddenLoading();
                // }, 3000);
            })
            .catch((error) => {
                setTimeout(() => {
                    signOut();
                }, 3000);
                loadingService.HiddenLoading();
                alertService.Error(`失敗 ! ${error?.response?.data}`);
                console.log('change plan error = ', error);
            });
    }

    return (
        <>
            <div className="flex justify-center items-center">
                <div>
                    <UserProfile />
                    <button
                        onClick={() => { changeToInsurance() }}
                        type="button"
                        className="inline-flex items-center gap-x-1.5 rounded-md mb-12
                        bg-teal-500 px-1 mt-2 text-lg font-semibold text-white 
                        shadow-sm hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 
                        focus-visible:outline-offset-2 focus-visible:outline-teal-700"
                    >
                        轉換為保險業務員帳號
                    </button>
                    {/* <button
                        onClick={() => {
                                user?.reload().then((res) => {
                                    console.log('res=', JSON.stringify(res));
                                    console.log(JSON.stringify(user?.organizationMemberships));
                                });
                            }
                        }
                        type="button"
                        className="inline-flex items-center gap-x-1.5 rounded-md mb-12
                        bg-teal-500 px-1 mt-2 text-lg font-semibold text-white 
                        shadow-sm hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 
                        focus-visible:outline-offset-2 focus-visible:outline-teal-700"
                    >
                        reload
                    </button> */}
                </div>
            </div>
        </>
    )
}